import React, { useRef } from "react";
import { jsPDF } from "jspdf";
import "jspdf-autotable"; //

export default function ReviewBookingSummary({ summaryData, id }) {
  const summaryRef = useRef();

  const handleDownloadPDF = () => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "pt",
      format: "a4", // Ensures standard size to avoid cutoff
    });

    const element = document.querySelector(".booking-summary");

    doc.html(element, {
      callback: function (doc) {
        doc.save("booking-summary.pdf");
      },
      margin: [20, 20, 20, 20],
      x: 10,
      y: 10,
      autoPaging: "text",
      html2canvas: {
        scale: id ? 0.55 : 0.58, // Adjust scale if content is cut off
        useCORS: true,
      },
    });
  };

  if (!summaryData?.data) return null;

  const {
    totalRoomCharges,
    totalServiceCharges,
    totalRestaurantCharges=0,
    totalTaxAmount,
    totalDiscounts,
    servicesData = [],
    restaurantData = [],
    totalAmountPaid=0,
  } = summaryData?.data;

  const { check_in_date_time, check_out_date_time, package_ids } =
    summaryData?.payload;

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: 10,
        }}
      >
        <span
          onClick={handleDownloadPDF}
          style={{
            backgroundColor: "#4CAF50",
            color: "white",
            padding: "8px 16px",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            fontWeight: "bold",
          }}
        >
          Download
        </span>
      </div>
      <div
        ref={summaryRef}
        className="booking-summary"
        style={{
          maxWidth: "auto",
          margin: "auto",
          fontFamily: "Arial, sans-serif",
          margin: 20,
          padding: 20,
          border: "1px solid #ddd",
          borderRadius: 6,
        }}
      >
        <h2>Booking Summary</h2>

        <p>
          <strong>Check-in:</strong>{" "}
          {new Date(check_in_date_time).toLocaleString()}
        </p>
        <p>
          <strong>Check-out:</strong>{" "}
          {new Date(check_out_date_time).toLocaleString()}
        </p>
        {/* <p><strong>Guests:</strong> {guest_count}</p> */}

        {/* <h3>Room Details</h3> */}
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ borderBottom: "1px solid #ccc", textAlign: "left" }}>
              <th style={{ padding: 8 }}>Item Type</th>
              <th style={{ padding: 8 }}>Description</th>
              <th style={{ padding: 8 }}>Details</th>
              <th style={{ padding: 8 }}>Price</th>
              <th style={{ padding: 8 }}>Qty/Nights</th>
              <th style={{ padding: 8 }}>Sub Total</th>
              <th style={{ padding: 8 }}>Discount</th>
              <th style={{ padding: 8 }}>Total</th>
              <th style={{ padding: 8 }}>Paid</th>
            </tr>
          </thead>
          <tbody>
            {summaryData?.data?.roomsPrice?.map(
              (
                {
                  price_per_night,
                  total_nights,
                  total_amount,
                  payment_status,
                  discount,
                  room,
                },
                index
              ) => (
                <tr key={index} style={{ borderBottom: "1px solid #eee" }}>
                  <td style={{ padding: 8 }}>Room</td>
                  <td style={{ padding: 8 }}>{room?.room?.room_type || "-"}</td>
                  <td style={{ padding: 8 }}>
                    Room {room?.room_number || "-"}
                  </td>
                  <td style={{ padding: 8 }}>&#8377;{price_per_night}</td>
                  <td style={{ padding: 8 }}>{total_nights || "-"} nights</td>
                  <td style={{ padding: 8 }}>&#8377;{total_amount}</td>
                  <td style={{ padding: 8 }}>&#8377;{discount}</td>
                  <td style={{ padding: 8 }}>
                    &#8377;{total_amount - discount}
                  </td>
                  <td style={{ padding: 8 }}>
                    {payment_status ? "Yes" : "No"}
                  </td>
                </tr>
              )
            )}
            {servicesData?.map(
              (
                {
                  price_per_night,
                  quantity,
                  total_amount,
                  payment_status,
                  discount,
                  service,
                },
                index
              ) => (
                <tr key={index} style={{ borderBottom: "1px solid #eee" }}>
                  <td style={{ padding: 8 }}>Service</td>
                  <td style={{ padding: 8 }}>{service?.package_name || "-"}</td>
                  <td style={{ padding: 8 }}>{"-"}</td>
                  <td style={{ padding: 8 }}>&#8377;{price_per_night}</td>
                  <td style={{ padding: 8 }}>{quantity || "-"} </td>
                  <td style={{ padding: 8 }}>&#8377;{total_amount}</td>
                  <td style={{ padding: 8 }}>-</td>
                  <td style={{ padding: 8 }}>&#8377;{total_amount}</td>
                  <td style={{ padding: 8 }}>
                    {payment_status ? "Yes" : "No"}
                  </td>
                </tr>
              )
            )}
            {/* {restaurantData?.map(
              (
                {
                  price_per_night,
                  quantity,
                  total_amount,
                  payment_status,
                  discount,
                  restaurant,
                },
                index
              ) => (
                <tr key={index} style={{ borderBottom: "1px solid #eee" }}>
                  <td style={{ padding: 8 }}>Restaurant</td>
                  <td style={{ padding: 8 }}>{restaurant?.name || "-"}</td>
                  <td style={{ padding: 8 }}>{restaurant?.description || "-"}</td>
                  <td style={{ padding: 8 }}>&#8377;{price_per_night?.toFixed?.(2) || "0.00"}</td>
                  <td style={{ padding: 8 }}>{quantity || "-"}</td>
                  <td style={{ padding: 8 }}>&#8377;{discount?.toFixed?.(2) || "0.00"}</td>
                  <td style={{ padding: 8 }}>-</td>
                  <td style={{ padding: 8 }}>&#8377;{total_amount?.toFixed?.(2) || "0.00"}</td>
                  <td style={{ padding: 8 }}>{payment_status ? "Yes" : "No"}</td>
                </tr>
              )
            )}
             */}
            {restaurantData?.map(
              (
                {
                  price_per_night,
                  quantity,
                  total_amount,
                  payment_status,
                  discount,
                  tip,
                  gstAmount,
                  serviceCharge,
                  restaurant,
                },
                index
              ) => {
                const subTotal = price_per_night * quantity;
                const serviceChargeAmount = (subTotal * serviceCharge) / 100;
                return (
                  <tr key={index} style={{ borderBottom: "1px solid #eee" }}>
                    <td style={{ padding: 8 }}>Restaurant</td>
                    <td style={{ padding: 8 }}>{restaurant?.name || "-"}</td>
                    <td style={{ padding: 8 }}>
                      {restaurant?.description || "-"}
                    </td>
                    <td style={{ padding: 8 }}>
                      &#8377;{price_per_night?.toFixed(2) || "0.00"}
                    </td>
                    <td style={{ padding: 8 }}>{quantity || "-"}</td>
                    <td style={{ padding: 8 }}>&#8377;{subTotal.toFixed(2)}</td>
                    <td style={{ padding: 8 }}>
                      Tip: &#8377;{tip.toFixed(2)}
                      <br />
                      GST: &#8377;{gstAmount.toFixed(2)}
                      <br />
                      SC: &#8377;{serviceChargeAmount.toFixed(2)}
                      <br />
                      Discount: -&#8377;
                      {((parseFloat(subTotal) * discount) / 100).toFixed(2)}
                    </td>
                    <td style={{ padding: 8 }}>
                      &#8377;{total_amount?.toFixed(2)}
                    </td>
                    <td style={{ padding: 8 }}>
                      {payment_status ? "Yes" : "No"}
                    </td>
                  </tr>
                );
              }
            )}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan="8" className="label">
                Room Total (after discount)
              </td>
              <td>&#8377;{totalRoomCharges}</td>
            </tr>
            <tr>
              <td colSpan="8" className="label">
                Service Total
              </td>
              <td>&#8377;{totalServiceCharges}</td>
            </tr>

            {restaurantData?.length ? (
              <tr>
                <td colSpan="8" className="label">
                  Order Total
                </td>
                <td>&#8377;{totalRestaurantCharges}</td>
              </tr>
            ) : (
              ""
            )}
            <tr>
              <td colSpan="8" className="label">
                Tax
              </td>
              <td>&#8377;{totalTaxAmount}</td>
            </tr>
            <tr>
              <td colSpan="8" className="label">
                Grand Total
              </td>
              <td>
                &#8377;
                {parseFloat(
                  totalRoomCharges +
                    totalServiceCharges +
                    totalRestaurantCharges +
                    totalTaxAmount
                ).toFixed(2)}
              </td>
            </tr>
            {id &&<>
            <tr>
              <td colSpan="8" className="label">
                Paid
              </td>
              <td>&#8377;{parseFloat(totalAmountPaid).toFixed(2)}</td>
            </tr>
            <tr>
              <td colSpan="8" className="label">
                Unpaid
              </td>
              <td>
                &#8377;
                {parseFloat(
                  totalRoomCharges +
                    totalServiceCharges +
                    totalRestaurantCharges +
                    totalTaxAmount -
                    totalAmountPaid
                ).toFixed(2)}
              </td>
            </tr>
            </>}
          </tfoot>
        </table>
        <br />
        {/* <h3>Package Details</h3>

      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr style={{ borderBottom: "1px solid #ccc", textAlign: "left" }}>
            <th style={{ padding: 8 }}>Package Name</th>
            <th style={{ padding: 8 }}>Package price</th>
          </tr>
        </thead>
        <tbody>
          {package_ids.map(({ package_name, package_price }, index) => (
            <tr key={index} style={{ borderBottom: "1px solid #eee" }}>
              <td style={{ padding: 8 }}>{package_name || "-"}</td>
              <td style={{ padding: 8 }}>{package_price || "-"}</td>
            </tr>
          ))}
        </tbody>
      </table> */}

        {/* <div style={{ marginTop: 20, textAlign: "right", fontWeight: "bold" }}>
        <p>Total Room Charges: &#8377;{totalRoomCharges}</p>
        <p>Total Tax Amount: &#8377;{totalTaxAmount}</p>
        <p style={{ fontSize: 18, borderTop: "1px solid #ccc", paddingTop: 10 }}>
          Grand Total: &#8377;{totalRoomCharges + totalTaxAmount}
        </p>
      </div> */}
      </div>
    </div>
  );
}
